// Angular
import { Injectable } from '@angular/core';

// RxJS
import { Observable, Subject } from 'rxjs';

/**
 * The generic state service interface
 */
export interface IGenericStateService {
  /**
   * The generic message observable
   */
  genericMessage$: Observable<string>;
  
  /**
   * Show a generic message
   * @param message The message to show
   */
  showGeneric(message: string): void;
}

@Injectable({
  providedIn: 'root'
})
export class GenericStateService implements IGenericStateService{

  /**
   * The generic subject
   */
  private generic$$ = new Subject<string>();
  /**
   * The generic message observable
   */
  genericMessage$: Observable<string> = this.generic$$.asObservable();

  /**
   * Public method to show a generic message
   * @param message The message to show
   */
  showGeneric(message: string) {
    this.generic$$.next(message);
  }
}
